import { DATA_API_CONSTANT } from './constant/api.constant';
import httpGetService from './http-Get.service';
import httpDeleteService from './http-delete.service';
import httpPutService from './http-put.service';
import httpPostService from './http.Post.service';



 const login=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.LOGIN, data)
}


















//webapp



const adminlogin=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.ADMIN_LOGIN, data)
}

const employeeList=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_EMPLOYEE_LIST)
}

const uploadPaySheet=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.UPLOAD_PAYSHEET, data)
}

const paysheetUploadedDates=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.UPLOADED_DATES)
}

const getPaysheetData=(id)=>{
   const url = `${DATA_API_CONSTANT.GET_PAYSHEET_DATA}${id}`;
  return httpGetService.getDataFromAPI(url);
}

const updateEmployeeDetails=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_EMPLOYEE_DETAILS, data)

}

const updatePaysheet=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_PAYSHEET, data);
}

const sendOTP=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.SEND_OTP, data)
}

const forgotPassword=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.FORGOT_PASSWORD, data)
}

const auditLogs=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.AUDIT_LOGS, data)
}

const deletePaysheet=(data)=>{
  return httpDeleteService.deleteDataFromAPI(DATA_API_CONSTANT.DELETE_PAYSHEET, data)
}



const bulkUploadSheet=(data)=>{
  return httpPostService.postTOAPI(DATA_API_CONSTANT.USER_UPLOAD_PAYSHEET,data)
}

const getUserSheets=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_USERSHEET_FILES)
}

const removeUserSheet=(data)=>{
return httpDeleteService.deleteDataFromAPI(DATA_API_CONSTANT.REMOVE_USERSHEET,data)
}

const getUsersheetDetails =()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_USERSHEET_DETAILS)
}

const updateusersheetdata=(data)=>{
  return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_USER_SHEET_DATA,data)
}

const getFeatures=()=>{
  return httpGetService.getDataFromAPI(DATA_API_CONSTANT.GET_FEATURES);
}

const updateFeatureStatus=(data)=>{
 return httpPutService.putTOAPI(DATA_API_CONSTANT.UPDATE_FEATURE_STATUS, data);
}




/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  login,
  adminlogin,
  uploadPaySheet,
  employeeList,
  paysheetUploadedDates,
  getPaysheetData,
  updateEmployeeDetails,
  updatePaysheet,
  sendOTP,
  forgotPassword,
  auditLogs,
  deletePaysheet,
  getFeatures,
  updateFeatureStatus,
  
  bulkUploadSheet,
  getUserSheets,
  removeUserSheet,
  getUsersheetDetails,
  updateusersheetdata
  

}